































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { Student, SearchCondition } from '@/modules/student';
import { Account } from '@/modules/me';
import { UserTypes } from '@/enums/userTypes';
import { GradeYears, getGradeYearName } from '@/enums/gradeYears';
import QRCard from '@/components/student/qrCard.vue';
import pdfMake from 'pdfmake/build/pdfmake';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { ElForm } from 'element-ui/types/form';
import DialogWrapper from '@/components/dialogWrapper.vue';
import Axios from 'axios';
import { StudentAccountRequest } from '@/models/accountRequest';
import { CreditcardSettingResponse } from '@/models/creditcardSettingResponse';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({
  components: {
    'qr-card': QRCard,
  },
})
export default class StudentList extends AvaivaledVue {
  private getGradeYearName = getGradeYearName;

  private showSearchCondition = true;

  private checkedStudentList = new Array<Student>();
  private checkChanging = false;

  private useCreditcard: boolean = false;

  private bulkDeleteConfirmValue = 'はい';
  private bulkDeleteStudentsFormRule = {
    checkYes: [
      { required: true, message: `削除する場合は「${this.bulkDeleteConfirmValue}」を入力してください` },
      {
        pattern: `^${this.bulkDeleteConfirmValue}$`,
        message: `削除する場合は「${this.bulkDeleteConfirmValue}」を入力してください`,
        trigger: 'blur'
        },
    ],
  };

  get loading(): boolean {
    return this.$store.state.student.loading;
  }

  get countAll(): number {
    if (this.$store.state.student.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.student.countAll;
    }
  }

  get students(): Student[] {
    return this.$store.state.student.students;
  }

  get condition(): SearchCondition {
    return this.$store.state.student.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isAdmin(): boolean {
    return this.userRole === UserTypes.Admin ||
      this.userRole === UserTypes.Owner ||
      this.userRole === UserTypes.AdminTutor;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  private async created() {
    this.useCreditcard = false;

    if (!this.user) {
      await this.$store.dispatch('me/fetchMyData');
    }

    switch (this.userRole) {
      case UserTypes.All:
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        if ((this.availableFunction & FunctionTypes.Bill) === FunctionTypes.Bill) {
          // 請求機能
          try {
            const res = await Axios.get<CreditcardSettingResponse>('/api/bill-settings/creditcard');
            if (res.data.enabled) {
              this.useCreditcard = true;
            }
          } catch (error) {
            //
          }
        }
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.checkChanging = true;
    await this.$store.dispatch('student/searchStudents', this.condition);
    this.checkStudents();
    this.checkChanging = false;
  }

  private checkStudents() {
    const table = this.$refs.studentTable as any;
    this.students.forEach((row) => {
      if (!!this.checkedStudentList.find((student) => student.id === row.id)) {
        table.toggleRowSelection(row, true);
      }
    });
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private studentCellStyle({ column }: any) {
    switch (column.property) {
      case 'check':
        return null;
      default:
        return { cursor: 'pointer' };
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onChangeSelection(selection: Student[]) {
    if (this.checkChanging) { return; }
    this.students.forEach((student) => {
      if (!selection.find((value) => value.id === student.id)) {
        const index = this.checkedStudentList.findIndex((value) => value.id === student.id);
        if (index >= 0) {
          this.checkedStudentList.splice(index, 1);
        }
      }
    });
    const addStudents = selection.filter((student) => {
      return !this.checkedStudentList.find((value) => value.id === student.id);
    });
    if (addStudents.length > 0) {
      this.checkedStudentList.push(...addStudents);
    }
  }

  private clearCheckedStudent() {
    this.checkedStudentList.splice(0, this.checkedStudentList.length);
    const table = this.$refs.studentTable as any;
    table.clearSelection();
  }

  private checkdStudentClose(studentId: string) {
    const index = this.checkedStudentList.findIndex((value) => value.id === studentId);
    if (index >= 0) {
      this.checkedStudentList.splice(index, 1);
    }

    const row = this.students.find((value) => value.id === studentId);
    if (!!row) {
      const table = this.$refs.studentTable as any;
      table.toggleRowSelection(row, false);
    }
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: Student) {
    this.$router.push({
      name: 'StudentDetails',
      params: {
        studentId: row.id
      }
    });
  }

  private onCellClick(row: Student, column: any) {
    switch (column.property) {
      case 'check':
        break;
      default:
        this.$router.push({
          name: 'StudentDetails',
          params: {
            studentId: row.id
          }
        });
        break;
    }
  }

  private onBulkCreateStudent() {
    this.$router.push({ name: 'StudentBulkCreate' });
  }

  private onCreateStudent() {
    this.$router.push({ name: 'StudentCreate' });
  }

  private async onOutputQRCode() {
    const fileName = `QR画像一括出力_${(this as any).$moment().format('YYYYMMDD')}.pdf`;

    const qrcardList = this.$el.getElementsByClassName('qrcard');
    if (qrcardList.length === 0) {
      return;
    }

    const docDefinition = {
      pageMargins: [ 25, 25, 0, 0 ],
      content: new Array(),
    };

    let canvas = document.createElement('canvas');
    let ctx: CanvasRenderingContext2D;
    let dataURI: string;
    const pdfImageWidth = 588;
    const imageType = 'image/png';

    for (let i = 0; i < qrcardList.length; i++) {
      const num = i % 10;
      const x = (num % 2 === 0) ? 0 : 395;
      const y = Math.floor(num / 2)  * 239;

      if (num === 0) {
        if (i > 0) {
          dataURI = canvas.toDataURL(imageType);
          docDefinition.content.push({
            image: dataURI,
            width: pdfImageWidth
          });
        }

        canvas = document.createElement('canvas');
        canvas.height = 1300;
        canvas.width = 900;
        ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
      }

      const el = qrcardList[i] as Element;
      const cv = el.firstElementChild as HTMLCanvasElement;
      const imageURI = cv.toDataURL(imageType);

      let imageLoaded = false;
      const qrImage = new Image();
      qrImage.src = imageURI;
      qrImage.onload = () => {
        ctx.drawImage(qrImage, x, y);
        imageLoaded = true;
      };

      while (!imageLoaded) {
        await new Promise((resolve) => setTimeout(resolve, 1));
      }
    }

    dataURI = canvas.toDataURL(imageType);
    docDefinition.content.push({
      image: dataURI,
      width: pdfImageWidth
    });

    pdfMake.createPdf(docDefinition).download(fileName);
  }

  private async onOutputReservation() {
    try {
      const outputCondition = this.condition;
      outputCondition.schoolName = this.user.schoolName;
      outputCondition.studentIdList = [];
      this.checkedStudentList.forEach((student) => {
        outputCondition.studentIdList.push(student.userId);
      });

      const response = await this.$store.dispatch('student/downloadReservationList', outputCondition);
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private submitBulkDeleteStudentsForm() {
    (this.$refs.bulkDeleteStudentsForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.bulkDeleteStudentsDialog as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async bulkDeleteStudents() {
    const targetStudents = this.checkedStudentList.map((student) => student.id);
    const bulkDeleteCount = targetStudents.length;
    try {
      const form = {
        bulkDeleteCount,
        checkYes: '',
      };
      await (this.$refs.bulkDeleteStudentsDialog as DialogWrapper).open({ ...form });
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('student/bulkDeleteStudents', targetStudents);
      this.clearCheckedStudent();
      this.loadData();
      this.$notify({
        title: '一括削除完了',
        message: `${bulkDeleteCount}件 の生徒を一括削除しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async onExportCSV() {
    try {
      const request: StudentAccountRequest = {
        id: undefined,
        userId: undefined,
        lastName: undefined,
        firstName: undefined,
        lastNameKana: undefined,
        firstNameKana: undefined,
        genderType: undefined,
        birthDay: undefined,
        postalCode: undefined,
        address: undefined,
        phone: undefined,
        note: undefined,
        tutorIdList: this.condition.tutorList,
        ordinarySchoolId: this.condition.ordinarySchoolId === ''
          ? undefined : this.condition.ordinarySchoolId as string,
        ordinaryPreSchoolId: undefined,
        ordinaryElementarySchoolId: undefined,
        ordinaryMiddleSchoolId: undefined,
        ordinaryHighSchoolId: undefined,
        gradeYear: this.condition.gradeYear === ''
          ? undefined : this.condition.gradeYear as number,
        tagList: this.condition.tagList,
        keyWord: this.condition.keyWord,
        creditcardRegistered: this.condition.creditcardRegistered === null
          ? undefined : this.condition.creditcardRegistered,
        perPage: this.condition.perPage,
        page: this.condition.page,
        sort: this.condition.sort,
        reservableCount: undefined,
        subjectIdList: undefined,
        studentIdList: undefined,
      };
      const response = await Axios.post(
        '/api/Account/DownloadStudentsCSV',
        request,
        {
          responseType: 'blob'
        }
      );

      let fileName = '';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = decodeURI(matches[1].replace(/['"]/g, ''));
          }
        }

      if (fileName === '') {
          fileName = '生徒エクスポート.csv';
        }

      if (!(window.navigator as any).msSaveOrOpenBlob) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const url = (window.navigator as any).msSaveOrOpenBlob(new Blob([response.data]), fileName);
      }
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
          message: error.response ? error.response.data : '生徒エクスポートのダウンロードに失敗しました',
        position: 'bottom-right'
      });
    }
  }
}
